<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      size="mini"
    >
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {},
    validEvent() {
      return this.$refs.table
        .fullValidate()
        .then(() => true)
        .catch(() => false)
    },
  },
}
</script>
